import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1),
            alignItems: 'center',
        },
        noticeText: {
            fontSize: '14px',
            alignSelf: 'flex-start',
        },
        fileContainer: {
            width: '300px',
            '&& div[role="presentation"]': {
                marginBottom: theme.spacing(0.4),
            },
        },
        fileInputLabel: {
            paddingTop: '0 !important',
        },
        file: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        fileName: {
            color: theme.palette.primary[700],
            fontSize: '14px',
        },
        fileDeleteIcon: {
            cursor: 'pointer',
            height: '24px',
            width: '24px',
        },
        bold: {
            fontWeight: 700,
        },
    }
})

export default useStyles
